<template>
  <div class="wechat-open-login-panel">
    <el-text v-if="wechatLoginConfigured" type="info" size="small">{{ hintText }}</el-text>
    <div v-show="wechatLoginConfigured" :id="containerId" class="wx-login-container" />
  </div>
</template>

<script setup>
import { computed, toRef, useId } from 'vue'
import { useWechatOpenQr } from '../composables/useWechatOpenQr'
import { apiAbsUrl } from '@/util/http'

const props = defineProps({
  hintText: { type: String, default: '请使用微信扫描二维码登录' },
  redirectUri: { type: String, default: '' },
  oauthState: { type: String, default: '' }
})

const containerId = useId()
const defaultLoginRedirect = apiAbsUrl('user/login/wechat/open/callback')

const redirectUriRef = computed(() => props.redirectUri?.trim() || defaultLoginRedirect)

const { wechatLoginConfigured } = useWechatOpenQr({
  containerId,
  redirectUriRef,
  oauthStateRef: toRef(props, 'oauthState')
})
</script>

<style lang="scss" scoped>
.wechat-open-login-panel {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding-top: 4px;
}

.wx-login-container {
  width: 100%;
  min-height: 252px;
  display: flex;
  justify-content: center;
}
</style>
